/* eslint-disable camelcase */
import React from 'react'
import ProductCollectionItem from 'containers/ProductCollection/components/Item'
import logUtil from 'utils/log'
import isDeluxeSampleOptionUtil from 'modules/variant/utils/is-deluxe-sample-option'

/**
 * @param props
 * @param props.analyticEventPrefix
 * @param props.isCompact
 * @param props.question
 * @return {JSX.Element}
 * @constructor
 */
export default function QuestionProduct (props) {
  const {
    isCompact,
    analyticEventPrefix
  } = props

  /**
   * @type import('modules/post-sample-survey/types').PSSurveyQuestionEnt
   */
  const question = props.question
  const {
    fullsize_display_name,
    fullsize_price,
    fullsize_price_after_discount,
    product_id,
    product_handle,
    fullsize_variant_id,
    fullsize_is_in_stock,
    product_review_rating,
    product_review_rating_count,
    fullsize_image_url,
    sample_variant_content
  } = question
  const hasDeluxeSample = isDeluxeSampleOptionUtil(sample_variant_content.size)

  logUtil('QuestionProduct').debug('question=', question)

  const product = {
    product_id,
    id: product_id,
    variant_id: fullsize_variant_id,
    name: fullsize_display_name,
    price: fullsize_price,
    discountPrice: fullsize_price_after_discount,
    handle: product_handle,
    variantId: fullsize_variant_id,
    rating: product_review_rating,
    ratingCount: product_review_rating_count,
    image: fullsize_image_url,
    isCompact,
    isAvailable: fullsize_is_in_stock,
    hasSample: !!sample_variant_content,
    hasDeluxeSample,
    variant_image_url: fullsize_image_url,
    image_url: fullsize_image_url,
    title: fullsize_display_name,
    ...question
  }

  logUtil('QuestionProduct').debug('product=', product)

  return (
    <ProductCollectionItem
      productVariant={product}
      analyticEventPrefix={analyticEventPrefix}
      isQuestionProduct
      isFullSize
    />
  )
}
